import React from 'react';

const PowerBiReportDisplayConfig = ({
  embedToken,
  embedUrl,
  reportId,
  reportTitle,
  pageName = '',
}) => (
  <div data-testid="chart-config-wrapper">
    <p data-testid="powerbi-report-title">{`Power BI Report Title: ${reportTitle}`}</p>
    <p data-testid="embed-token">{`Embed Token: ${embedToken}`}</p>
    <p data-testid="embed-url">{`Embed Url: ${embedUrl}`}</p>
    <p data-testid="report-id">{`report Id: ${reportId}`}</p>
    <p data-testid="powerbi-report-page-name">{`Power BI Report Page Name: ${pageName}`}</p>
  </div>
);

export default PowerBiReportDisplayConfig;
